(() => {
  if (customElements.get('nn-naked-explainer')) return;
  customElements.define('nn-naked-explainer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.observer?.disconnect();
      this.finishDrag?.();
      this.controller = new AbortController();
      const track = this.querySelector('[data-explainer-track]');
      if (!track) return;
      const options = { signal:this.controller.signal };
      const prev = this.querySelector('[data-explainer-prev]');
      const next = this.querySelector('[data-explainer-next]');
      const update = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
        this.querySelector('[data-explainer-controls]').hidden = end <= 2;
      };
      const move = direction => {
        const first = track.firstElementChild;
        const distance = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
        track.scrollBy({ left:direction * distance, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      let drag = null;
      let suppressClick = false;
      const finishDrag = () => {
        if (!drag) return;
        const { id, moved } = drag;
        drag = null;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
        if (moved) {
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, 0);
          const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          track.scrollTo({ left:Math.round(track.scrollLeft / step) * step, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
        update();
      };
      this.finishDrag = finishDrag;
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || track.scrollWidth <= track.clientWidth + 2) return;
        if (e.target.closest('button,input,select,textarea,summary,[role="button"]')) return;
        drag = { id:e.pointerId, x:e.clientX, y:e.clientY, left:track.scrollLeft, moved:false };
      }, options);
      track.addEventListener('pointermove', e => {
        if (!drag || drag.id !== e.pointerId) return;
        const dx = e.clientX - drag.x;
        const dy = e.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { drag = null; return; }
          if (Math.abs(dx) < 8) return;
          drag.moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
        }
        e.preventDefault();
        track.scrollLeft = drag.left - dx;
      }, options);
      track.addEventListener('pointerup', finishDrag, options);
      track.addEventListener('pointercancel', finishDrag, options);
      track.addEventListener('lostpointercapture', finishDrag, options);
      track.addEventListener('pointerleave', () => { if (drag && !drag.moved) drag = null; }, options);
      track.addEventListener('dragstart', e => e.preventDefault(), options);
      track.addEventListener('click', e => {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault(); e.stopImmediatePropagation();
      }, { ...options, capture:true });
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, options);
      track.addEventListener('keydown', e => {
        if (e.target !== track || !['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.observer = new ResizeObserver(update); this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.finishDrag?.(); this.controller?.abort(); this.observer?.disconnect(); }
  });
})();
